export const SET_LOADING = 'SET_LOADING';
export const SET_COMPANY = 'SET_COMPANY';
